import React, { useEffect, useState } from 'react';
import { useParams, Link } from 'react-router-dom';
import { listLegal, getLegal } from '../lib/api';
import { Shield, FileText, Loader2 } from 'lucide-react';

export default function Legal() {
  const { slug } = useParams();
  const [doc, setDoc] = useState(null);
  const [docs, setDocs] = useState([]);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    let cancelled = false;
    (async () => {
      setLoading(true);
      try {
        const [d, all] = await Promise.all([getLegal(slug), listLegal()]);
        if (cancelled) return;
        setDoc(d); setDocs(all);
      } catch (err) {
        setDoc({ title: 'Not found', content: 'This legal document does not exist.', slug });
      } finally { if (!cancelled) setLoading(false); }
    })();
    return () => { cancelled = true; };
  }, [slug]);

  if (loading) return <div className="flex items-center gap-2 text-white/60 py-20"><Loader2 className="w-5 h-5 animate-spin" /> Loading…</div>;

  return (
    <div className="grid lg:grid-cols-[240px_1fr] gap-8" data-testid="legal-page">
      <aside className="card-shell p-4 h-max sticky top-20">
        <div className="flex items-center gap-2 text-[#ffcf52] mb-3"><Shield className="w-4 h-4" /><span className="uppercase text-[11px] tracking-widest font-bold">Legal</span></div>
        <nav className="space-y-1">
          {docs.map(d => (
            <Link key={d.slug} to={`/legal/${d.slug}`}
              className={`flex items-center gap-2 px-3 py-2 rounded-lg text-[13.5px] ${slug === d.slug ? 'bg-white/10 text-white' : 'text-white/65 hover:bg-white/[0.04]'}`}
              data-testid={`legal-nav-${d.slug}`}>
              <FileText className="w-4 h-4" /> {d.title}
            </Link>
          ))}
        </nav>
      </aside>
      <article className="max-w-[780px]">
        <h1 className="font-display text-[34px] md:text-[42px] leading-tight">{doc?.title}</h1>
        {doc?.updated_at && <div className="text-white/45 text-[12.5px] mt-2">Last updated {new Date(doc.updated_at).toLocaleDateString()}</div>}
        <div className="prose-legal mt-6 text-white/85 leading-relaxed whitespace-pre-line text-[15px]">{doc?.content}</div>
      </article>
    </div>
  );
}
